export default function ScrollToTopOfPageOnLoad() {
  //This has a set timeout because it attempts to load before the page loads
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 2);
}
